/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { Modal, Stack, Grid, Button, Box, Tooltip } from '@mui/material';

import { defaultModalOptions } from '../../shared/constantVariable';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import Notification from '../../shared/notification-modal';
import { getBorderColor } from '../../shared/utils';
import { closeIconBlack } from '../../shared/assets/images';
import { convertUnitValues_flow, convertUnitValues_power, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import './pelton-wheel.scss';
import { output_data } from './output_data';

let unit_set_dict = { 'Volume Flow': 'gpm', 'Pressure': 'atm', 'Temperature': '°C', 'Liquid Volume': 'gal', 'Flux': 'gfd', 'Power': 'kW' };
const headerData = ['Parameter', 'Unit', 'Values'];
let output_dataCopy = JSON.parse(JSON.stringify(output_data));
let currentVal = 0;
const resRange = { min: 0, max: 0 };
let currentFlag = true;

const PeltonWheelForm = (props) => {
  const { visiblePeltonWheel, pletonWheel, handleClosePeltonWheel, disabledStripperAndExplorerTab, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [peltonWheelVal, setPeltonWheelVal] = useState({});
  const [isShowErrorMessage] = useState(false);

  let pelton_wheel = [...output_dataCopy.pelton_wheel];

  const getCurrentValue = (e) => {
    if (currentFlag) {
      currentFlag = false;
      currentVal = (e.target.value) ? Number(e.target.value) : 0;
    }
  };
  const getpeltonwheelName = () => {
    let peltonwheel = '';
    const local = localStorage.getItem(pletonWheel.id);
    if (local) {
      peltonwheel = ` - ${local}`;
    } else {
      peltonwheel = ` - Pump ${Number(get(pletonWheel, 'id', '').split('_')[1]) + 1}`;
    }
    return peltonwheel;
  };
  const decimalValue = (val) => {
    return val.toFixed(3);
  };

  const handleClosePelton_Wheel = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleClosePeltonWheel();
  };

  const handleClosePeltonWheelModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleClosePelton_Wheel(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleClosePeltonWheel();
    };
  };
  /* function call when click on OK button */
  const setDataOnStorage = () => {
    const previous_pressure_unit = 'atm';
    const peltonWheelObj = { 'lp_dicharge_pres': 0, 'cost_power': 0, 'turbine_eff': 0, 'Unit Type': 'ERD', 'erd_type': 'pelton', 'finalData': {} };
    pelton_wheel.forEach((ele) => {
      peltonWheelObj.finalData[ele.key] = ele.val;
      if (ele.key === 'LP Discharge Pressure') {
        const convertedVal = Number(convertUnitValues_pressure(ele.val, unit_set_dict.Pressure, previous_pressure_unit));
        peltonWheelObj.lp_dicharge_pres = Number(convertedVal);
        peltonWheelObj.finalData[ele.key] = convertedVal;
      } else if (ele.key === 'Cost of power') {
        peltonWheelObj.cost_power = Number(ele.val);
      } else if (ele.key === 'Turbine Efficiency') {
        peltonWheelObj.turbine_eff = Number(ele.val);
      }
    });

    saveFormDataInLocalStorage({
      record: peltonWheelObj,
      type: 'pelton_exc',
      id: pletonWheel.id,
      item: 'pelton_wheel-dict'
    });
    localStorage.setItem('pelton-unit-work', JSON.stringify(unit_set_dict));
    handleClosePeltonWheel();
    getBorderColor(pletonWheel.id);
    setokbuttonFormAutoSave(true);
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
  };

  const changeUnit = () => {
    const previous_pressure_unit = 'atm';
    let previousUnit = localStorage.getItem('pelton-unit-work');
    if (previousUnit) {
      previousUnit = JSON.parse(previousUnit);
    }
    let pelton_dict = localStorage.getItem('pelton_wheel-dict');
    if (pelton_dict) {
      const { id } = pletonWheel;
      pelton_dict = get(JSON.parse(localStorage.getItem('pelton_wheel-dict')), 'pelton_exc', {});
      pelton_dict = (pelton_dict[id] && pelton_dict[id].finalData) ? pelton_dict[id].finalData : '';
    }
    pelton_wheel.forEach((ele) => {
      if (['RO Permeate Flow'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict['Volume Flow'];
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_flow(parseFloat(ele.val), previousUnit['Volume Flow'], unit_set_dict['Volume Flow'])));
        }
      } else if (['LP Discharge Pressure', 'RO Feed Pressure', 'Membrane Diff Press'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Pressure;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_pressure(parseFloat(ele.val), previousUnit.Pressure, unit_set_dict.Pressure)));
        }
      } else if (['Electricity Generated', 'HP Pump Shaft Power', 'HP Motor Shaft Power', 'HP Motor Electrical Power', 'Power Savings', 'Total Power Cons'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Power;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_power(parseFloat(ele.val), previousUnit.Power, unit_set_dict.Power)));
        }
      }
      if (pelton_dict) {
        if (['LP Discharge Pressure', 'Cost of power', 'Turbine Efficiency'].indexOf(ele.key) >= 0) {
          let val = Number(pelton_dict[ele.key]);
          if (ele.key === 'LP Discharge Pressure') {
            val = Number(convertUnitValues_pressure(val, previous_pressure_unit, unit_set_dict.Pressure));
          }
          ele.val = decimalValue(val);
        }
      }
    });
    setPeltonWheelVal(pelton_wheel);
  };
  const updateWorkExchangerValue = (data) => {
    for (let i = 0; i < pelton_wheel.length; i += 1) {
      pelton_wheel[i].val = data[pelton_wheel[i].key] ? decimalValue(Number(data[pelton_wheel[i].key])) : decimalValue(0);
    }
    changeUnit();
  };
  const showWarningMsg = (message) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      message, // `Target Resistivity must be between ${resRange.min} and ${resRange.max}`
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions)
    });
  };
  const changeVal = (ind, eve) => {
    if (pelton_wheel[ind].key === 'LP Discharge Pressure') {
      resRange.min = 0; resRange.max = 68.0457;
      const previous_pressure_unit = 'atm';
      resRange.min = Number(convertUnitValues_pressure(resRange.min, previous_pressure_unit, unit_set_dict.Pressure));
      resRange.max = Number(convertUnitValues_pressure(resRange.max, previous_pressure_unit, unit_set_dict.Pressure));
      if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
        showWarningMsg(`LP Discharge Pressure must be between ${resRange.min} ${unit_set_dict.Pressure} and ${resRange.max} ${unit_set_dict.Pressure}`);
        pelton_wheel[ind].val = currentVal;
      } else {
        pelton_wheel[ind].val = eve.target.value;
      }
    } else if (pelton_wheel[ind].key === 'Cost of power') {
      resRange.min = 0; resRange.max = 10;
      if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
        showWarningMsg(`Cost of Power must be between ${resRange.min} and ${resRange.max}`);
        pelton_wheel[ind].val = currentVal;
      } else {
        pelton_wheel[ind].val = eve.target.value;
      }
    } else if (pelton_wheel[ind].key === 'Turbine Efficiency') {
      resRange.min = 0; resRange.max = 95;
      if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
        showWarningMsg(`Net transfer Efficiencies must be between ${resRange.min} and ${resRange.max}`);
        pelton_wheel[ind].val = currentVal;
      } else {
        pelton_wheel[ind].val = eve.target.value;
      }
    }
    disabledStripperAndExplorerTab();
    setPeltonWheelVal(pelton_wheel);
  };
  const blurVal = (ind, eve) => {
    pelton_wheel[ind].val = decimalValue(Number(eve.target.value));
    setPeltonWheelVal(pelton_wheel);
    currentFlag = true;
  };
  useEffect(() => {
    output_dataCopy = JSON.parse(JSON.stringify(output_data));
    pelton_wheel = [...output_dataCopy.pelton_wheel];
    if (localStorage.getItem('unit_set_dict')) {
      unit_set_dict = JSON.parse(localStorage.getItem('unit_set_dict'));
    }
    // Edit Case
    if (localStorage.getItem('ro_ouput_data')) {
      let data = JSON.parse(localStorage.getItem('ro_ouput_data'));
      if (data) {
        data = Object.values(JSON.parse(localStorage.getItem('ro_ouput_data'))).filter((ele) => {
          return ele.unit_type === 'PW';
        });
        if (data.length > 0) {
          data = data[0];
        }
        const pelton_data = data;
        if (Object.keys(pelton_data).length) {
          setTimeout(() => {
            updateWorkExchangerValue(pelton_data.output_user);
          }, 0);
        } else {
          changeUnit();
        }
      }
    } else {
      changeUnit();
    }
  }, []);
  return (
    <Modal hideBackdrop open={visiblePeltonWheel} onClose={handleClosePeltonWheelModal} className='splitter-modal'>
      <Box>
        <Rnd
          default={{
            width: '70%',
            x: ((window.innerWidth / 2) - ((70 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((60 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='50%'
          cancel='.no_drag'
          className='pelton-wheel-box'>
          <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
          <Grid className='pelton-wheel-wrapper'>
            <Grid item xs={12} className='pelton-wheel-header-grid'>
              <div className='pelton-wheel-grid-title rufusBld no_drag S_heading forground-text-primary'>{`Pelton Wheel ${getpeltonwheelName()}`}</div>
              <div className='pelton-wheel-grid-container no_drag'>
                <Tooltip title='Close'>
                  <img src={closeIconBlack} alt='close' onClick={handleClosePeltonWheelModal} className='pointer' />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='pelton-wheel-body-container sansW4SeLig'>
              <Grid item xs={12} style={{ maxHeight: '70vh', overflow: 'hidden scroll' }}>
                <div className='pelton-wheel-input-form'>
                  <div className='pelton-wheel-input'>
                    <div className='input-params' style={{ height: '300px', 'marginRight': '15px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Input Parameters')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        {peltonWheelVal.length > 0 && peltonWheelVal.map((ele, ind) => {
                          if (ele.name === 'input') {
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li className={ele.class}>
                                  <span className='no_drag S_Regular'>
                                    <input
                                      onMouseDown={(e) => getCurrentValue(e)}
                                      onBlur={(e) => { blurVal(ind, e); }}
                                      onChange={(e) => { changeVal(ind, e); }}
                                      onFocus={e => e.target.select()}
                                      type='number' disabled={!ele.class} value={ele.val} />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                    <div className='input-params' style={{ height: '300px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Pelton wheel Performance')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        {peltonWheelVal.length > 0 && peltonWheelVal.map((ele, ind) => {
                          if (ele.name === 'performance') {
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li className={ele.class}>
                                  <span className='no_drag S_Regular'>
                                    <input
                                      onMouseDown={(e) => getCurrentValue(e)}
                                      onBlur={(e) => { blurVal(ind, e); }}
                                      onChange={(e) => { changeVal(ind, e); }}
                                      onFocus={e => e.target.select()}
                                      type='number' disabled={!ele.class} value={ele.val} />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className='edi-button'>
                  <Stack spacing={2} direction='row'>
                    <Button variant='contained' size='small' className='sansW4SeLig ok no_drag M_Bold Primary_Default_Button' onClick={() => setDataOnStorage()}>{translateObject('OK')}</Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default PeltonWheelForm;